import React, { useState, useEffect, useRef } from 'react';
import { json, useLocation, useNavigate } from 'react-router-dom';
import LeftTabs from '../components/LeftTabs/LeftTabs';
import RightTabs from '../components/RightTabs/RightTabs';
import { getResponse, insertMessage, getMessageDetails, getmessagebyId } from '../api';
import './ResultPage.css';
import DocumentLoader from '../components/DocumentLoader/DocumentLoader';
import SearchBar from "../components/SearchBar/SearchBar";
import { FaCopy } from 'react-icons/fa';
import { saveAs } from 'file-saver';
import {
    Document,
    Packer,
    Paragraph,
    Table,
    TableCell,
    TableRow,
    TextRun,
    AlignmentType,
    WidthType,
    VerticalAlign,
    TableLayoutType,
    BorderStyle
} from "docx";

import { TbFileDownload } from "react-icons/tb";
import { BsTranslate } from "react-icons/bs";
import { FiInfo, FiRefreshCw } from "react-icons/fi";
import InteractiveParagraph from "../components/Paragraph/InteractiveParagraph";
import ReferenceTooltip from '../components/ReferenceToolTip/ReferenceTooltip';
import ErrorAlert from "../components/ErrorAlert/ErrorAlert";
import 'react-toastify/dist/ReactToastify.css';
import Toast from "../components/Notification/Toast";
import { useTranslation } from 'react-i18next';
import { fileToBase64 } from '../utils/fileToBase64';  // base64 helper


const ResultsPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    let chatId = location.state.chatId;
    const initialQuery = location.state.searchQuery || [];
    const [searchQuery, setSearchQuery] = useState(initialQuery);
    const [error, setError] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState(location.state?.selectedFiles || []);  // <-- selectedFiles burada doğru şekilde alınıyor
    const [fileProcessType, setFileProcessType] = useState(location.state?.fileProcessType || 'include');


    // İlk sorguyu direkt queries array'ine ekleyerek başlıyoruz
    const [queries, setQueries] = useState(initialQuery ? [initialQuery] : []);

    const [response, setResponse] = useState(location.state?.response);
    const [messageDetails, setMessageDetails] = useState(location.state.messageDetails);


    const [isLoading, setIsLoading] = useState(false);
    const messageBoxRef = useRef(null);
    const [selectedMessageId, setSelectedMessageId] = useState(null);

    const [allMessages, setAllMessages] = useState(location?.state?.allMessage);
    const isInitialMount = useRef(true);
    const [activeReference, setActiveReference] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState(null);
    const [resultSearchQuery, setResultSearchQuery] = useState('');
    const [shouldSearch, setShouldSearch] = useState(false);
    const [showToast, setShowToast] = useState(false);

    const [searchSettings, setSearchSettings] = useState(
        location.state?.features || {
            tur: 'arastirma_makalesi',
            citationFormat: 'APA',
            section: 'giris',
            language: 'turkish',
            discipline: ['multidisipliner'],
            searchScope: 'all',
            pageSize: '1',
            articleOrder: 'auto',
            categories: 'article',
            startYear: null,
            endYear: null,
            mode: "text"
        }
    );


    useEffect(() => {
        if (!location.state) {
            console.log('Unauthorized access attempt to results page. Redirecting to home...');
            navigate('/', { replace: true });
        }

    }, [location.state, navigate]);



    const formatSortReference = (reference, format) => {
        const authorsRaw = reference.authors || "";
        const authorsArray = authorsRaw.replace(/,\s*$/, '').split(',').map(author => {
            const [firstName, lastName] = (author.trim() || "").split(' ');
            return `${lastName || ""}, ${(firstName || "").charAt(0)}.`;
        });

        const authorsFormatted = authorsArray.join(', ').replace(/, ([^,]*)$/, ', & $1');

        // console.log(format);

        switch (format) {
            case 'APA':
            case 'APA-7':
                const authorsList = (reference.authors || '')
                    .replace(/,\s*$/, '') // sondaki virgül varsa sil
                    .split(',')
                    .map(a => a.trim())
                    .filter(a => a.length);

                // Her isimde en son kelimeyi soyadı kabul et
                const surnames = authorsList.map(name => {
                    const parts = name.split(/\s+/);
                    return parts[parts.length - 1]; // Soyad olarak son kelime
                });

                let citation;
                if (surnames.length === 1) {
                    citation = surnames[0]; // örn: (Gültekin, 2022)
                } else if (surnames.length === 2) {
                    citation = `${surnames[0]} & ${surnames[1]}`; // örn: (Gültekin & Yılmaz, 2022)
                } else {
                    citation = `${surnames[0]} et al.`; // örn: (Gültekin et al., 2022)
                }

                return `(${citation}, ${reference.publicationYear})`;
            case 'IEEE':
                return `[${reference.refNumber}]`;
            case 'Harvard': {
                // 1) Ham yazar listesini virgülle parçala, fazladan boşluğu ve boş girdileri at
                const authorsList = (reference.authors || '')
                    .replace(/,\s*$/, '')
                    .split(',')
                    .map(a => a.trim())
                    .filter(Boolean);

                // 2) Her isimde en son kelimeyi soyadı kabul et
                const surnames = authorsList.map(name => {
                    const parts = name.split(/\s+/);
                    return parts[parts.length - 1]; // sadece soyadı
                });

                // 3) Harvard in‐text formatı
                let citation;
                if (surnames.length === 1) {
                    citation = surnames[0]; // (Gültekin, 2020)
                } else if (surnames.length === 2) {
                    citation = `${surnames[0]} and ${surnames[1]}`; // (Yılmaz and Demir, 2020)
                } else if (surnames.length === 3) {
                    citation = `${surnames[0]}, ${surnames[1]} and ${surnames[2]}`; // (Yılmaz, Demir and Aydın, 2020)
                } else {
                    citation = `${surnames[0]} et al.`; // (Yılmaz et al., 2020)
                }

                return `(${citation}, ${reference.publicationYear})`;
            }

            case 'CHICAGO': {
                // 1) Yazarları virgüle göre ayır, temizle
                const authorsList = (reference.authors || '')
                    .replace(/,\s*$/, '') // sondaki fazladan virgül varsa sil
                    .split(',')
                    .map(a => a.trim())
                    .filter(Boolean);

                // 2) Her yazarın soyadını çıkar (son kelimeyi al)
                const surnames = authorsList.map(name => {
                    const parts = name.split(/\s+/);
                    return parts[parts.length - 1];
                });

                // 3) Chicago in-text citation kurallarına göre yazımı hazırla
                let citation;
                if (surnames.length === 1) {
                    citation = surnames[0];
                } else if (surnames.length === 2) {
                    citation = `${surnames[0]} and ${surnames[1]}`;
                } else if (surnames.length === 3) {
                    citation = `${surnames[0]}, ${surnames[1]}, and ${surnames[2]}`; // Oxford virgülü
                } else {
                    citation = `${surnames[0]} et al.`;
                }

                // 4) Parantezli çıktı (virgülsüz)
                return `(${citation} ${reference.publicationYear})`;
            }

            case 'VANCOUVER':
                return `[${reference.refNumber}]`;
            case 'MLA': {
                // 1) Ham yazar listesini ayır, gereksiz virgülü ve boşlukları temizle
                const authorsList = (reference.authors || '')
                    .replace(/,\s*$/, '')
                    .split(',')
                    .map(a => a.trim())
                    .filter(Boolean);

                // 2) Her yazarın soyadını al (en son kelime)
                const surnames = authorsList.map(name => {
                    const parts = name.split(/\s+/);
                    return parts[parts.length - 1]; // örn: "Abdurrazak GÜLTEKİN" → "GÜLTEKİN"
                });

                // 3) MLA in-text gösterim:
                let citation;
                if (surnames.length === 1) {
                    citation = surnames[0]; // (Gültekin)
                } else if (surnames.length === 2) {
                    citation = `${surnames[0]} and ${surnames[1]}`; // (Yılmaz and Demir)
                } else {
                    citation = `${surnames[0]} et al.`; // (Yılmaz et al.)
                }

                return `(${citation})`;
            }

            case 'TURABIAN': {
                // 1) Ham yazar listesini ',' ile ayırıp temizle
                const authorsList = (reference.authors || '')
                    .replace(/,\s*$/, '')
                    .split(',')
                    .map(a => a.trim())
                    .filter(Boolean);

                // 2) Her isimden soyadını çıkar (ilk kelime dışındaki tümü soyadı)
                const surnames = authorsList.map(name => {
                    const parts = name.split(/\s+/);
                    return parts.slice(1).join(' ') || parts[0];
                });

                // 3) Turabian (author-date) kuralı:
                //    1 yazar → A
                //    2 yazar → A and B
                //    ≥3 yazar → A et al.
                let citation;
                if (surnames.length === 1) {
                    citation = surnames[0];
                } else if (surnames.length === 2) {
                    citation = `${surnames[0]} and ${surnames[1]}`;
                } else {
                    citation = `${surnames[0]} et al.`;
                }

                // 4) Parantez içinde yazar ve yıl
                return `(${citation} ${reference.publicationYear})`;
            }

            case 'OSCOLA': {
                // 1) Ham yazar listesini virgülle ayırıp temizle
                const authorsList = (reference.authors || '')
                    .replace(/,\s*$/, '')
                    .split(',')
                    .map(a => a.trim())
                    .filter(Boolean);

                // 2) Soyad çıkarma
                const surnames = authorsList.map(name => {
                    const parts = name.split(/\s+/);
                    return parts.slice(1).join(' ') || parts[0];
                });

                // 3) OSCOLA kuralı (no Oxford comma):
                //    1 yazar → A
                //    2 yazar → A and B
                //    3 yazar → A, B and C
                //    ≥4 yazar → A et al.
                let citation;
                if (surnames.length === 1) {
                    citation = surnames[0];
                } else if (surnames.length === 2) {
                    citation = `${surnames[0]} and ${surnames[1]}`;
                } else if (surnames.length === 3) {
                    citation = `${surnames[0]}, ${surnames[1]} and ${surnames[2]}`;
                } else {
                    citation = `${surnames[0]} et al.`;
                }

                // 4) Yazar adından sonra parantez içinde yıl
                return `${citation} (${reference.publicationYear})`;
            }
            case 'CSE': {
                // CSE Name–Year style (up to 10 names, “et al.” if >10)
                const authorsList = (reference.authors || '')
                    .replace(/,\s*$/, '')
                    .split(',')
                    .map(a => a.trim())
                    .filter(Boolean);

                // Soyadı olarak isimdeki ilk boşluktan sonrası
                const surnames = authorsList.map(name => {
                    const parts = name.split(/\s+/);
                    return parts.slice(1).join(' ') || parts[0];
                });

                let citationAuthors;
                if (surnames.length === 1) {
                    citationAuthors = surnames[0];
                } else if (surnames.length === 2) {
                    citationAuthors = `${surnames[0]} and ${surnames[1]}`;
                } else if (surnames.length <= 10) {
                    // Son isimden önce Oxford virgülü
                    citationAuthors = `${surnames.slice(0, -1).join(', ')}, and ${surnames[surnames.length - 1]}`;
                } else {
                    citationAuthors = `${surnames[0]} et al.`;
                }

                // Parantezli Name–Year
                return `(${citationAuthors} ${reference.publicationYear})`;
            }
            case 'AMA':
                return `${authorsArray.join(' ')}. ${reference.publicationYear}.`;
            case 'BLUEBOOK': {
                // 1) Ham yazar listesini virgülle böl, fazladan virgülü at, trimle
                const authorsList = (reference.authors || '')
                    .replace(/,\s*$/, '')
                    .split(',')
                    .map(a => a.trim())
                    .filter(Boolean);

                // 2) Soyad çıkarma: ilk kelime dışındakiler soyadı
                const surnames = authorsList.map(name => {
                    const parts = name.split(/\s+/);
                    return parts.slice(1).join(' ') || parts[0];
                });

                // 3) Birleştirme: “A, B & C” değil, hepsini virgülle ayırıp sonuna “and” ekleyelim
                let citationAuthors;
                if (surnames.length === 1) {
                    citationAuthors = surnames[0];
                } else if (surnames.length === 2) {
                    citationAuthors = `${surnames[0]} and ${surnames[1]}`;
                } else {
                    // Oxford virgülü kullanarak
                    citationAuthors = `${surnames.slice(0, -1).join(', ')}, and ${surnames.slice(-1)[0]}`;
                }

                // 4) Bluebook footnote tarzında: “A, B, and C, “Title,” (Year).”
                return `${citationAuthors}, "${reference.title}," (${reference.publicationYear}).`;
            }

            case 'NLM': {
                // 1) Ham yazar listesini virgülle böl, fazladan virgülü at, trimle
                const authorsList = (reference.authors || '')
                    .replace(/,\s*$/, '')
                    .split(',')
                    .map(a => a.trim())
                    .filter(Boolean);

                // 2) NLM’de “Soyad Initials” biçimi tercih edilir
                const nlmAuthors = authorsList.map(name => {
                    const parts = name.split(/\s+/);
                    const first = parts[0] || '';
                    const initials = parts
                        .slice(1)
                        .map(n => n.charAt(0))
                        .join('');
                    return `${parts.slice(1).join(' ') ? parts.slice(1).join(' ') : parts[0]} ${initials}`;
                }).join(', ');

                // 3) NLM referans dokümanı: “A AB, C CD. Title. Journal. Year;Volume(Issue):Pages.”
                const journal = reference.primaryLocationDisplayName || '';
                const volIssue = reference.volume ? `${reference.volume}` : '';
                const pages = reference.pages ? `:${reference.pages}` : '';

                return `${nlmAuthors}. ${reference.title}. ${journal}. ${reference.publicationYear}${volIssue ? `;${volIssue}` : ''}${pages}.`;
            }
            default:
                return `(${authorsFormatted}, ${reference.publicationYear})`;
        }
    };


    const formatMarkdown = (text) => {
        if (!text) return [];

        const paragraphs = text.split('\n\n').filter(p => p.trim());


        const formatReference = (reference, format) => {
            const authorsRaw = reference.authors || "";
            const authorsArray = authorsRaw.replace(/,\s*$/, '').split(',').map(author => {
                const [firstName, lastName] = (author.trim() || "").split(' ');
                return `${lastName || ""}, ${(firstName || "").charAt(0)}.`;
            });

            const authorsFormatted = authorsArray.join(', ').replace(/, ([^,]*)$/, ', & $1');

            // console.log(format);

            switch (format) {
                case 'APA':
                case 'APA-7':
                    const authorsList = (reference.authors || '')
                        .replace(/,\s*$/, '') // sondaki virgül varsa sil
                        .split(',')
                        .map(a => a.trim())
                        .filter(a => a.length);

                    // Her isimde en son kelimeyi soyadı kabul et
                    const surnames = authorsList.map(name => {
                        const parts = name.split(/\s+/);
                        return parts[parts.length - 1]; // Soyad olarak son kelime
                    });

                    let citation;
                    if (surnames.length === 1) {
                        citation = surnames[0]; // örn: (Gültekin, 2022)
                    } else if (surnames.length === 2) {
                        citation = `${surnames[0]} & ${surnames[1]}`; // örn: (Gültekin & Yılmaz, 2022)
                    } else {
                        citation = `${surnames[0]} et al.`; // örn: (Gültekin et al., 2022)
                    }

                    return `(${citation}, ${reference.publicationYear})`;
                case 'IEEE':
                    return `[${reference.refNumber}]`;
                case 'Harvard': {
                    // 1) Ham yazar listesini virgülle parçala, fazladan boşluğu ve boş girdileri at
                    const authorsList = (reference.authors || '')
                        .replace(/,\s*$/, '')
                        .split(',')
                        .map(a => a.trim())
                        .filter(Boolean);

                    // 2) Her isimde en son kelimeyi soyadı kabul et
                    const surnames = authorsList.map(name => {
                        const parts = name.split(/\s+/);
                        return parts[parts.length - 1]; // sadece soyadı
                    });

                    // 3) Harvard in‐text formatı
                    let citation;
                    if (surnames.length === 1) {
                        citation = surnames[0]; // (Gültekin, 2020)
                    } else if (surnames.length === 2) {
                        citation = `${surnames[0]} and ${surnames[1]}`; // (Yılmaz and Demir, 2020)
                    } else if (surnames.length === 3) {
                        citation = `${surnames[0]}, ${surnames[1]} and ${surnames[2]}`; // (Yılmaz, Demir and Aydın, 2020)
                    } else {
                        citation = `${surnames[0]} et al.`; // (Yılmaz et al., 2020)
                    }

                    return `(${citation}, ${reference.publicationYear})`;
                }

                case 'CHICAGO': {
                    // 1) Yazarları virgüle göre ayır, temizle
                    const authorsList = (reference.authors || '')
                        .replace(/,\s*$/, '') // sondaki fazladan virgül varsa sil
                        .split(',')
                        .map(a => a.trim())
                        .filter(Boolean);

                    // 2) Her yazarın soyadını çıkar (son kelimeyi al)
                    const surnames = authorsList.map(name => {
                        const parts = name.split(/\s+/);
                        return parts[parts.length - 1];
                    });

                    // 3) Chicago in-text citation kurallarına göre yazımı hazırla
                    let citation;
                    if (surnames.length === 1) {
                        citation = surnames[0];
                    } else if (surnames.length === 2) {
                        citation = `${surnames[0]} and ${surnames[1]}`;
                    } else if (surnames.length === 3) {
                        citation = `${surnames[0]}, ${surnames[1]}, and ${surnames[2]}`; // Oxford virgülü
                    } else {
                        citation = `${surnames[0]} et al.`;
                    }

                    // 4) Parantezli çıktı (virgülsüz)
                    return `(${citation} ${reference.publicationYear})`;
                }

                case 'VANCOUVER':
                    return `[${reference.refNumber}]`;
                case 'MLA': {
                    // 1) Ham yazar listesini ayır, gereksiz virgülü ve boşlukları temizle
                    const authorsList = (reference.authors || '')
                        .replace(/,\s*$/, '')
                        .split(',')
                        .map(a => a.trim())
                        .filter(Boolean);

                    // 2) Her yazarın soyadını al (en son kelime)
                    const surnames = authorsList.map(name => {
                        const parts = name.split(/\s+/);
                        return parts[parts.length - 1]; // örn: "Abdurrazak GÜLTEKİN" → "GÜLTEKİN"
                    });

                    // 3) MLA in-text gösterim:
                    let citation;
                    if (surnames.length === 1) {
                        citation = surnames[0]; // (Gültekin)
                    } else if (surnames.length === 2) {
                        citation = `${surnames[0]} and ${surnames[1]}`; // (Yılmaz and Demir)
                    } else {
                        citation = `${surnames[0]} et al.`; // (Yılmaz et al.)
                    }

                    return `(${citation})`;
                }

                case 'TURABIAN': {
                    // 1) Ham yazar listesini ',' ile ayırıp temizle
                    const authorsList = (reference.authors || '')
                        .replace(/,\s*$/, '')
                        .split(',')
                        .map(a => a.trim())
                        .filter(Boolean);

                    // 2) Her isimden soyadını çıkar (ilk kelime dışındaki tümü soyadı)
                    const surnames = authorsList.map(name => {
                        const parts = name.split(/\s+/);
                        return parts.slice(1).join(' ') || parts[0];
                    });

                    // 3) Turabian (author-date) kuralı:
                    //    1 yazar → A
                    //    2 yazar → A and B
                    //    ≥3 yazar → A et al.
                    let citation;
                    if (surnames.length === 1) {
                        citation = surnames[0];
                    } else if (surnames.length === 2) {
                        citation = `${surnames[0]} and ${surnames[1]}`;
                    } else {
                        citation = `${surnames[0]} et al.`;
                    }

                    // 4) Parantez içinde yazar ve yıl
                    return `(${citation} ${reference.publicationYear})`;
                }

                case 'OSCOLA': {
                    // 1) Ham yazar listesini virgülle ayırıp temizle
                    const authorsList = (reference.authors || '')
                        .replace(/,\s*$/, '')
                        .split(',')
                        .map(a => a.trim())
                        .filter(Boolean);

                    // 2) Soyad çıkarma
                    const surnames = authorsList.map(name => {
                        const parts = name.split(/\s+/);
                        return parts.slice(1).join(' ') || parts[0];
                    });

                    // 3) OSCOLA kuralı (no Oxford comma):
                    //    1 yazar → A
                    //    2 yazar → A and B
                    //    3 yazar → A, B and C
                    //    ≥4 yazar → A et al.
                    let citation;
                    if (surnames.length === 1) {
                        citation = surnames[0];
                    } else if (surnames.length === 2) {
                        citation = `${surnames[0]} and ${surnames[1]}`;
                    } else if (surnames.length === 3) {
                        citation = `${surnames[0]}, ${surnames[1]} and ${surnames[2]}`;
                    } else {
                        citation = `${surnames[0]} et al.`;
                    }

                    // 4) Yazar adından sonra parantez içinde yıl
                    return `${citation} (${reference.publicationYear})`;
                }
                case 'CSE': {
                    // CSE Name–Year style (up to 10 names, “et al.” if >10)
                    const authorsList = (reference.authors || '')
                        .replace(/,\s*$/, '')
                        .split(',')
                        .map(a => a.trim())
                        .filter(Boolean);

                    // Soyadı olarak isimdeki ilk boşluktan sonrası
                    const surnames = authorsList.map(name => {
                        const parts = name.split(/\s+/);
                        return parts.slice(1).join(' ') || parts[0];
                    });

                    let citationAuthors;
                    if (surnames.length === 1) {
                        citationAuthors = surnames[0];
                    } else if (surnames.length === 2) {
                        citationAuthors = `${surnames[0]} and ${surnames[1]}`;
                    } else if (surnames.length <= 10) {
                        // Son isimden önce Oxford virgülü
                        citationAuthors = `${surnames.slice(0, -1).join(', ')}, and ${surnames[surnames.length - 1]}`;
                    } else {
                        citationAuthors = `${surnames[0]} et al.`;
                    }

                    // Parantezli Name–Year
                    return `(${citationAuthors} ${reference.publicationYear})`;
                }
                case 'AMA':
                    return `${authorsArray.join(' ')}. ${reference.publicationYear}.`;
                case 'BLUEBOOK': {
                    // 1) Ham yazar listesini virgülle böl, fazladan virgülü at, trimle
                    const authorsList = (reference.authors || '')
                        .replace(/,\s*$/, '')
                        .split(',')
                        .map(a => a.trim())
                        .filter(Boolean);

                    // 2) Soyad çıkarma: ilk kelime dışındakiler soyadı
                    const surnames = authorsList.map(name => {
                        const parts = name.split(/\s+/);
                        return parts.slice(1).join(' ') || parts[0];
                    });

                    // 3) Birleştirme: “A, B & C” değil, hepsini virgülle ayırıp sonuna “and” ekleyelim
                    let citationAuthors;
                    if (surnames.length === 1) {
                        citationAuthors = surnames[0];
                    } else if (surnames.length === 2) {
                        citationAuthors = `${surnames[0]} and ${surnames[1]}`;
                    } else {
                        // Oxford virgülü kullanarak
                        citationAuthors = `${surnames.slice(0, -1).join(', ')}, and ${surnames.slice(-1)[0]}`;
                    }

                    // 4) Bluebook footnote tarzında: “A, B, and C, “Title,” (Year).”
                    return `${citationAuthors}, "${reference.title}," (${reference.publicationYear}).`;
                }

                case 'NLM': {
                    // 1) Ham yazar listesini virgülle böl, fazladan virgülü at, trimle
                    const authorsList = (reference.authors || '')
                        .replace(/,\s*$/, '')
                        .split(',')
                        .map(a => a.trim())
                        .filter(Boolean);

                    // 2) NLM’de “Soyad Initials” biçimi tercih edilir
                    const nlmAuthors = authorsList.map(name => {
                        const parts = name.split(/\s+/);
                        const first = parts[0] || '';
                        const initials = parts
                            .slice(1)
                            .map(n => n.charAt(0))
                            .join('');
                        return `${parts.slice(1).join(' ') ? parts.slice(1).join(' ') : parts[0]} ${initials}`;
                    }).join(', ');

                    // 3) NLM referans dokümanı: “A AB, C CD. Title. Journal. Year;Volume(Issue):Pages.”
                    const journal = reference.primaryLocationDisplayName || '';
                    const volIssue = reference.volume ? `${reference.volume}` : '';
                    const pages = reference.pages ? `:${reference.pages}` : '';

                    return `${nlmAuthors}. ${reference.title}. ${journal}. ${reference.publicationYear}${volIssue ? `;${volIssue}` : ''}${pages}.`;
                }
                default:
                    return `(${authorsFormatted}, ${reference.publicationYear})`;
            }
        };

        return paragraphs.map((paragraph, index) => {
            const formattedContent = paragraph
                .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                .replace(/\[\[(\d+)\]\]/g, (match, num) => {
                    const all_reference = messageDetails?.all_references ? JSON.parse(messageDetails?.all_references) : null;
                    const reference = messageDetails?.all_references ? all_reference[parseInt(num) - 1] : null;

                    if (reference) {
                        const referenceText = formatReference(reference, searchSettings?.citationFormat);
                        return `
                            <span 
                                class="reference-citation" 
                                data-reference-id="${num}" 
                                onclick="window.handleReferenceClick(${num}, event)"
                                style="cursor: pointer; color: #2563eb;"
                            ><sup>${referenceText}</sup></span>`;
                    } else {
                        return `<span>${num}</span>`;
                    }
                })
                .trim();
            return (
                <InteractiveParagraph
                    key={index}
                    content={formattedContent}
                    paragraphId={index}
                    onUpdateParagraph={(newContent, paragraphId) => {
                        const updatedParagraphs = [...paragraphs];
                        updatedParagraphs[paragraphId] = newContent;
                        setResponse(prev => ({
                            ...prev,
                            text: updatedParagraphs.join('\n\n')
                        }));
                    }}
                />
            );
        });
    };


    useEffect(() => {
        window.handleReferenceClick = (refId, event) => {
            handleReferenceClick(refId, event);
        };
        return () => {
            delete window.handleReferenceClick;
        };
    }, [messageDetails]);
    // Sadece ilk yükleme için
    useEffect(() => {
        if (searchQuery && isInitialMount.current && !location.state?.messageDetails) {
            isInitialMount.current = false;
            fetchResponse(searchQuery);
        }

    }, []);
    useEffect(() => {
        if (searchQuery && isInitialMount.current && !location.state?.messageDetails) {
            isInitialMount.current = false;
            fetchResponse(searchQuery);
        }

    }, []);


    useEffect(() => {
        if (shouldSearch) {
            // resultSearchQuery yerine doğrudan search bar'daki değeri kullan
            const searchInput = document.querySelector('.search-input');
            if (searchInput && searchInput.value.trim()) {
                fetchResponse(searchInput.value.trim());
                setShouldSearch(false);
            }
        }
    }, [shouldSearch]);


    useEffect(() => {
        if (response?.id) {
            fetchMessageDetails(response.id);
            setSelectedMessageId(response.id);
        }
    }, [response?.id]);

    useEffect(() => {
        if (messageBoxRef.current && response) {
            messageBoxRef.current.scrollTop = 0;
        }
    }, [response]);


    const addToQueries = (query) => {
        if (!queries.includes(query)) {
            setQueries(prev => [...prev, query]);
        }
    };

    const handleSettingsApply = (newSettings) => {
        setSearchSettings(prevSettings => ({
            ...prevSettings,
            ...newSettings
        }));
    };


    const handleMessageSelect = async (query, messageId) => {
        if (messageId === selectedMessageId) return;

        setIsLoading(true);
        setSearchQuery(query);

        try {
            const details = await getmessagebyId(messageId);
            if (details.result) {
                setMessageDetails(details.data);
                setResponse(details.data);
                setSelectedMessageId(messageId);
            }
        } catch (error) {
            console.error("Message details fetch error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchMessageDetails = async (messageId) => {
        try {
            const details = await getMessageDetails(messageId);
            if (details.result) {
                setMessageDetails(details.data);
            }
        } catch (error) {
            console.error("Message details fetch error:", error);
        }
    };

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));


    const fetchResponse = async (query) => {
        try {
            setIsLoading(true);
            setMessageDetails(null);
            setResponse(null);
            setError(null);


            const base64Promises = selectedFiles.map(async (file, idx) => {
                const dataUrl = await fileToBase64(file);
                const commaIndex = dataUrl.indexOf(',');
                const base64Content = dataUrl.slice(commaIndex + 1);


                return {
                    filename: file.name,
                    contentType: file.type,
                    base64: base64Content
                };
            });

            const filesPayload = await Promise.all(base64Promises);

            const questionPayload = {
                chatId,
                question: query,
                features: searchSettings,
                fileProcessType
            };

            // +++++++
            // if (Array.isArray(filesPayload) && filesPayload.length > 0) {
            //     questionPayload.files = filesPayload;
            // }


            // Eğer filesPayload gerçekten en az 1 eleman içeriyorsa, o zaman "files" alanını ekle:
            if (Array.isArray(filesPayload) && filesPayload.length > 0) {
                questionPayload.files = filesPayload;
            }

            var questionResponse = await insertMessage(questionPayload);

            if (!questionResponse.data.id) {
                throw new Error('insertMessage (soru) beklenmeyen yanıt döndü.');
            }

            const processid = questionResponse.data.id;
            let responseStatus = 0;
            let dongu_timer_sayac = 0;

            // İlk yanıtı zaten aldın, şimdi döngüyle yenilerini çek
            while (responseStatus !== 1 && dongu_timer_sayac < 120) {
                dongu_timer_sayac++;
                await sleep(5000);             // 10 saniye bekle
                questionResponse = await getResponse(processid);

                // Gelen tüm JSON'u görebilmek için:
                //  console.log("questionResponse:", questionResponse);
                // console.log(    "questionResponse (JSON):", JSON.stringify(questionResponse, null, 2));
                // Status’a doğru yerden bak:
                responseStatus = questionResponse.data.data.status;
                // console.log("response_status:", responseStatus);
            }


            questionResponse.data = questionResponse.data.data;
            const newMessage = questionResponse.data;
            const newMessageId = newMessage.id;

            // console.log('Soru başarılı, dönen messageId:', newMessageId);
            setResponse(questionResponse.data);
            if (!allMessages.find(msg => msg.id === questionResponse.data.id)) {
                setAllMessages(prev => [...prev, { id: questionResponse.data.id, query }]);
            }

            // Gelen messageDetails varsa onu da state’e koyun:
            setMessageDetails(questionResponse.data);
            addToQueries(query);
            setSearchQuery(query);

        } catch (err) {
            console.error('API çağrısında hata oluştu:', err);
            setError(err.message || 'Beklenmeyen bir hata oluştu.');
            // Hata durumunda, yine “queries” dizinizi güncellemek isterseniz:
            if (query && !queries.includes(query)) {
                addToQueries(query);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleReferenceClick = (refId, event) => {
        event.preventDefault();

        // Referans verisini RightTabs'teki Referanslar bölümünden al
        if (messageDetails?.all_references) {
            try {
                const references = JSON.parse(messageDetails.all_references);
                const referenceData = references.find(ref => ref.refNumber === parseInt(refId));

                if (referenceData) {
                    const rect = event.target.getBoundingClientRect();
                    setTooltipPosition({
                        top: window.scrollY + rect.top,
                        left: rect.left + (rect.width / 2),
                        bottom: rect.bottom
                    });

                    // RightTabs component'ine geç ve ilgili referansa odaklan
                    const rightTabsElement = document.querySelector('.right-section');
                    if (rightTabsElement) {
                        // Referanslar tab'ini aktif yap
                        const referencesTabButton = rightTabsElement.querySelector('[data-tab="references"]');
                        if (referencesTabButton) {
                            referencesTabButton.click();
                        }

                        // İlgili referansa scroll yap ve highlight et
                        const referenceElement = rightTabsElement.querySelector(`[data-reference-id="${refId}"]`);
                        if (referenceElement) {
                            referenceElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            referenceElement.classList.add('highlighted');
                            setTimeout(() => {
                                referenceElement.classList.remove('highlighted');
                            }, 2000);
                        }
                    }
                }
            } catch (error) {
                console.error("Error parsing references:", error);
            }
        }
    };

    const handleNewSearch = () => {
        if (shouldSearch && resultSearchQuery.trim()) {
            fetchResponse(resultSearchQuery);
            setShouldSearch(false); // Aramayı sıfırla
        }
    };
    const handleSearchRequest = async () => {
        const searchInput = document.querySelector('.search-input');
        if (searchInput && searchInput.value.trim()) {
            const query = searchInput.value.trim();
            setResultSearchQuery(query);

            // searchQuery, files ve fileProcessType parametreleri ile arama yapılacak
            fetchResponse(query); // Bu fonksiyon, dosya ve arama türüne göre yanıtları getirecek
        }
    };


    const handleCopy = () => {
        if (!response?.text) {
            setShowToast(true);
            return;
        }

        navigator.clipboard.writeText(response.text)
            .then(() => {
                setShowToast(true);
            })
            .catch((err) => {
                console.error("Kopyalama hatası:", err);
                setError("Metin kopyalanırken bir hata oluştu.");
            });
    };


    const handleInfoClick = async () => {
        alert(
            t('alertforai')
        );
        return;
    };


    // handleDownload metotu buraya yazılmıştı.
    const handleDownload = async () => {
        if (!response?.text) {
            alert("İndirilecek bir içerik yok.");
            return;
        }


        try {
            // Stil tanımlamaları
            const styles = {
                title: {
                    size: 30,  // ~15pt
                    bold: true,
                    font: "Times New Roman",
                    spacing: {
                        after: 400
                    }
                },
                heading: {
                    size: 28,  // ~14pt
                    bold: true,
                    font: "Times New Roman",
                    spacing: {
                        before: 400,
                        after: 200
                    }
                },
                normal: {
                    size: 24,  // ~10pt
                    font: "Times New Roman",
                    spacing: {
                        line: 288, // 1.5 satır aralığı
                    }
                }
            };

            // Format helper function
            const formatReference = (ref, format) => {
                // Yardımcı: volume, issue, pages formatlama
                const volume = ref.volume ? ref.volume : '';
                const issue = ref.issue ? ref.issue : '';
                const pages = (ref.first_page && ref.last_page) ? `${ref.first_page}-${ref.last_page}` : '';

                // volume-issue string (ör: 10(2))
                let volIssue = '';
                if (volume && issue) volIssue = `${volume}(${issue})`;
                else if (volume) volIssue = volume;
                else if (issue) volIssue = `(${issue})`;

                // Sayfa aralığı stringi
                const pagesStr = pages ? (format === 'IEEE' ? `, pp. ${pages}` : `, pp. ${pages}`) : '';

                // DOI stringi (varsa başında nokta ve boşluk var)
                const doiStr = ref.doi ? (format === 'IEEE' ? ` DOI: ${ref.doi}` : `. DOI: ${ref.doi}`) : '';

                // refNumber string
                const refNumStr = ref.refNumber !== undefined ? `[${ref.refNumber}] ` : '';

                // authors - IEEE et al. örneği
                const firstAuthor = ref.authors ? ref.authors.split(',')[0] : '';
                const multipleAuthors = ref.authors && ref.authors.split(',').length > 1 ? ' et al.' : '';
                const ieeeAuthors = firstAuthor + multipleAuthors;

                switch (format.toUpperCase()) {
                    case 'APA-7':
                    case 'APA': {
                        console.log("Başladı....");
                        // 1. Yazar isimlerini dönüştür
                        const fixAuthorsToAPA = (authorStr) => {
                            const authors = (authorStr || '')
                                .replace(/,\s*$/, '') // sondaki virgülü kaldır
                                .split(',')
                                .map(name => {
                                    const parts = name.trim().split(/\s+/);
                                    const surname = parts.pop();
                                    const initials = parts.map(p => p.charAt(0).toUpperCase() + '.').join(' ');
                                    return `${surname}, ${initials}`;
                                });

                            // Doğru APA bağlaç formatı
                            if (authors.length === 1) {
                                return authors[0];
                            } else if (authors.length === 2) {
                                return `${authors[0]} & ${authors[1]}`;
                            } else {
                                return `${authors.slice(0, -1).join(', ')}, & ${authors[authors.length - 1]}`;
                            }
                        };


                        const authors = fixAuthorsToAPA(ref.authors);
                        const title = ref.title ? ref.title.charAt(0).toUpperCase() + ref.title.slice(1).toLowerCase() : '';
                        const journal = ref.primaryLocationDisplayName || '';
                        const volIssue = ref.volume ? `<i>${ref.volume}</i>${ref.issue ? `(${ref.issue})` : ''}` : '';
                        const pagesStr = ref.pages ? `, ${ref.pages}` : '';

                        // 2. DOI temizleme (çift https varsa kaldır)
                        const doiStr = ref.doi
                            ? `. https://doi.org/${ref.doi.replace(/^https?:\/\/(doi\.org\/)?/, '')}`
                            : (ref.url ? `. ${ref.url}` : '');

                        return `${authors} (${ref.publicationYear}). ${title}. <i>${journal}</i>${volIssue}${pagesStr}${doiStr}`;
                    }

                    case 'IEEE': {
                        const authors = ref.authors || ''; // Örn: "M. Karaköse, H. Yetiş"
                        const title = ref.title || '';
                        const journal = ref.primaryLocationDisplayName || '';
                        const vol = ref.volume ? `vol. ${ref.volume}` : '';
                        const issue = ref.issue ? `no. ${ref.issue}` : '';
                        const volIssue = vol && issue ? `${vol}, ${issue}` : (vol || issue);
                        const pagesStr = ref.pages ? `, pp. ${ref.pages}` : '';
                        const doiStr = ref.doi ? `. https://doi.org/${ref.doi}` : (ref.url ? `. ${ref.url}` : '');

                        return `${ref.refNumber ? `[${ref.refNumber}] ` : ''}${authors}, “${title},” ${journal}${volIssue ? `, ${volIssue}` : ''}${pagesStr}, ${ref.publicationYear}${doiStr}`;
                    } case 'HARVARD':
                        // Harvard: Yazarlar Yıl, 'Başlık', Dergi, cilt(sayı), sayfa aralığı, DOI
                        return `${ref.authors} ${ref.publicationYear}, '${ref.title}', ${ref.primaryLocationDisplayName}${volIssue ? ', vol. ' + ref.volume + (ref.issue ? `(${ref.issue})` : '') : ''}${ref.pages ? ', pp. ' + ref.pages : ''}${ref.doi ? ', https://doi.org/' + ref.doi : (ref.url ? ', ' + ref.url : '')}`;
                    case 'CHICAGO':
                        // Chicago: Yazarlar. "Başlık." Dergi cilt(sayı) (Yıl): sayfa aralığı. DOI
                        return `${ref.authors}. "${ref.title}." ${ref.primaryLocationDisplayName}${ref.volume ? ' ' + ref.volume : ''}${ref.issue ? `(${ref.issue})` : ''} (${ref.publicationYear})${ref.pages ? ': ' + ref.pages : ''}${ref.doi ? '. https://doi.org/' + ref.doi : (ref.url ? '. ' + ref.url : '')}`;
                    case 'VANCOUVER':
                    case 'CSE':
                    case 'AMA':
                    case 'NLM':
                        // Bu formatlarda genelde: [num] Yazarlar. Başlık. Dergi. Yıl; cilt(sayı): sayfa aralığı. DOI
                        return `${refNumStr}${ref.authors}. ${ref.title}. ${ref.primaryLocationDisplayName}. ${ref.publicationYear}${volIssue ? '; ' + volIssue : ''}${pagesStr}.${doiStr}`;

                    case 'MLA':
                        // MLA: Yazarlar. "Başlık." Dergi, cilt, sayı, yıl, sayfa aralığı. DOI
                        return `${ref.authors}. "${ref.title}." ${ref.primaryLocationDisplayName}${volIssue ? ', vol. ' + volIssue : ''}, ${ref.publicationYear}${pagesStr}${doiStr}`;

                    case 'TURABIAN':
                        // Turabian: Yazarlar. "Başlık." Dergi cilt(sayı) (Yıl). DOI
                        return `${ref.authors}. "${ref.title}." ${ref.primaryLocationDisplayName}${volIssue ? ' ' + volIssue : ''} (${ref.publicationYear})${pagesStr}${doiStr}`;

                    case 'OSCOLA':
                        // OSCOLA: Yazarlar, 'Başlık' (Yıl) Dergi DOI
                        return `${ref.authors}, '${ref.title}' (${ref.publicationYear}) ${ref.primaryLocationDisplayName}${doiStr}`;

                    case 'BLUEBOOK':
                        // Bluebook: [num] Yazarlar, Başlık, Yıl Dergi DOI
                        return `${refNumStr}${ref.authors}, ${ref.title}, ${ref.publicationYear} ${ref.primaryLocationDisplayName}${doiStr}`;

                    default:
                        // Default APA tarzı ama ref numaralı
                        return `${refNumStr}${ref.authors}. (${ref.publicationYear}). ${ref.title}. ${ref.primaryLocationDisplayName}${volIssue ? ', ' + volIssue : ''}${pagesStr}${doiStr}`;
                }
            };


            // Markdown temizleme fonksiyonu
            const cleanMarkdown = (text) => {
                return text
                    .replace(/\*\*/g, '')  // ** işaretlerini kaldır
                    .replace(/\[\[(\d+)\]\]/g, '[$1]') // [[1]] -> [1] formatına çevir
                    .trim();
            };

            // Başlık oluşturma (sadece bir kez)
            const title = new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: {
                    before: 200,
                    after: 400
                },
                children: [
                    new TextRun({
                        text: cleanMarkdown(response.question),
                        ...styles.title
                    })
                ]
            });

            const cleanMarkdownForDocx = (text, format, messageDetails) => {
                if (!text) {
                    console.warn('⚠️ Girdi metni boş.');
                    return '';
                }

                //    console.log('✅ Orijinal metin:', text);
                //    console.log('🔎 Seçilen format:', format);
                //    console.log('📦 messageDetails.all_references (ham):', messageDetails?.all_references);

                let cleaned = text.replace(/\*\*/g, '');
                //    console.log('🧼 Kalın temizlenmiş metin:', cleaned);

                cleaned = cleaned.replace(/\[\[(\d+)\]\]/g, (match, num) => {
                    //      console.log(`🔁 İşlenen referans etiketi: [[${num}]]`);

                    try {
                        const rawRefs = messageDetails?.all_references;
                        if (!rawRefs) {
                            console.warn('⚠️ messageDetails.all_references tanımsız.');
                            return `[${num}]`;
                        }

                        let allReferences;
                        try {
                            allReferences = JSON.parse(rawRefs);
                            //        console.log('✅ Parselenmiş referans listesi:', allReferences);
                        } catch (parseError) {
                            console.error('❌ JSON.parse hatası:', parseError);
                            return `[${num}]`;
                        }

                        const index = parseInt(num, 10) - 1;
                        const reference = allReferences[index];
                        //   console.log(`🔍 Referans [${index}]:`, reference);

                        if (!reference) {
                            console.warn(`⚠️ Referans bulunamadı: [[${num}]] (index: ${index})`);
                            return `[${num}]`;
                        }

                        if (typeof formatSortReference !== 'function') {
                            console.warn('❌ formatReference fonksiyonu mevcut değil.');
                            return `[${num}]`;
                        }

                        const citationText = formatSortReference(reference, format);
                        // console.log(`✅ formatReference çıktısı (format: ${format}):`, citationText);
                        return citationText;

                    } catch (err) {
                        console.error('❌ cleanMarkdownForDocx genel hata:', err);
                        return `[${num}]`;
                    }
                });

                // console.log('✅ Nihai temizlenmiş çıktı:', cleaned);
                return cleaned.trim();
            };




            const contentParagraphs = response.text
                .split('\n\n')
                .filter(para => para.trim())
                .map(text => {
                    return new Paragraph({
                        children: [
                            new TextRun({
                                text: cleanMarkdownForDocx(text, searchSettings?.citationFormat, messageDetails),
                                font: "Times New Roman",  // Font family
                                size: 24                  // 12 punto = 24 twips
                            })
                        ],
                        spacing: {
                            before: 200,
                            after: 200,
                            line: 288,   // 1.2 satır aralığı (240 * 1.2)
                        },
                        alignment: AlignmentType.JUSTIFIED
                    });
                });


            const keywordsList = new Paragraph({
                children: [
                    new TextRun({
                        text: messageDetails?.search_strategy
                            ? messageDetails.search_strategy
                                .replace(/[\[\]]/g, '')
                                .split(',')
                                .map(k => k.trim())
                                .join(', ')
                            : '',
                        font: "Times New Roman",
                        size: 24,      // 12 punto
                        italics: true,
                        ...styles.normal
                    }),
                ],
                alignment: AlignmentType.JUSTIFIED,  // Paragraf hizalaması buraya
                spacing: {
                    before: 200,
                    after: 200,
                    line: 288    // 1.2 satır aralığı istersen ekle
                }
            });


            const keywordsSpacing = new Paragraph({
                children: [
                    new TextRun({
                        text: '',
                        font: "Times New Roman",
                        size: 24,  // 12 punto
                        ...styles.normal
                    })
                ],
                spacing: { before: 400, after: 400 },
                alignment: AlignmentType.JUSTIFIED
            });


            // Anahtar Kelimeler başlığı — italic
            const keywordsHeading = new Paragraph({
                children: [
                    new TextRun({
                        text: "Anahtar Kelimeler",
                        font: "Times New Roman",
                        size: 24,       // 12 punto
                        italics: true,  // italic
                        ...styles.heading
                    }),
                ],
                spacing: {
                    before: 200,
                    after: 200,
                    line: 288, // 1.2 satır aralığı
                },
                alignment: AlignmentType.JUSTIFIED,
            });

            // Kaynakça başlığı — bold
            const referencesHeading = new Paragraph({
                children: [
                    new TextRun({
                        text: "Kaynakça",
                        font: "Times New Roman",
                        size: 24,      // 12 punto
                        bold: true,    // kalın
                        ...styles.heading
                    }),
                ],
                spacing: {
                    before: 200,
                    after: 200,
                    line: 288, // 1.2 satır aralığı
                },
                alignment: AlignmentType.JUSTIFIED,
            });



            // Kaynakça listesi oluşturma
            const referencesList = [];
            if (messageDetails?.all_references) {
                const references = JSON.parse(messageDetails.all_references);
                const citationFormat = searchSettings?.citationFormat || 'APA-7'; // Varsayılan format
                // console.log(citationFormat);
                let sortedReferences = references;

                // Eğer format APA ise alfabetik sırala
                if (citationFormat.toUpperCase() === "APA" || citationFormat.toUpperCase() === "APA-7") {
                    sortedReferences = references.sort((a, b) => {
                        const getSurname = (authorStr) => {
                            const firstAuthor = (authorStr || '').split(',')[0].trim();
                            const parts = firstAuthor.split(/\s+/);
                            return parts[parts.length - 1].toUpperCase(); // soyad, büyük harfe çevir
                        };
                        return getSurname(a.authors).localeCompare(getSurname(b.authors));
                    });
                }

                references.forEach(ref => {
                    referencesList.push(
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: formatReference(ref, citationFormat),
                                    font: "Times New Roman",
                                    size: 24,
                                    ...styles.normal
                                })
                            ],
                            spacing: {
                                before: 100,
                                after: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            indent: {
                                hanging: 360,
                                left: 360
                            }
                        })
                    );
                });
            }


            // Döküman oluşturma
            //searchSettings?.mode === "text"
            if (searchSettings?.mode === "text") {
                const doc = new Document({
                    sections: [{
                        properties: {
                            page: {
                                margin: {
                                    top: 1440, // 1 inç
                                    right: 1440,
                                    bottom: 1440,
                                    left: 1440
                                }
                            }
                        },
                        children: [
                            title,
                            ...contentParagraphs,
                            keywordsHeading,
                            keywordsList,
                            keywordsSpacing,
                            referencesHeading,
                            ...referencesList
                        ]
                    }]
                });
                // Dokümanı indirme
                const blob = await Packer.toBlob(doc);
                saveAs(blob, `${cleanMarkdown(response.question).slice(0, 50)}_makale.docx`);
            } else if (searchSettings.mode === "table") {
                const parser = new DOMParser();
                const doc = parser.parseFromString(response.text, "text/html");

                // Tüm <tr> etiketlerini seç
                const rows = doc.querySelectorAll("tr");

                // Her satırdaki içeriği bir listeye ekle
                const rowData = Array.from(rows).map(row => {
                    return Array.from(row.querySelectorAll("td")).map(td => td.textContent.trim());
                });
                //      console.log("Row Data: ", rowData);
                const jsonMessageDetails = JSON.parse(messageDetails?.all_references)
                const citationFormat = searchSettings?.citationFormat || 'APA-7';
                // yukarıdaki kodların hepsi başarılı bir biçimde çalışmaktadır.
                //     console.log("Json Message Details.", jsonMessageDetails);
                const columnRowData = rowData.slice(1, -1);
                const uzunMetin = rowData[rowData.length - 1];
                //     console.log("Column Data Row", columnRowData);

                // docx elementlerinin yaratılması.
                const tableRows = columnRowData.map((row, rowIndex) => {
                    return new TableRow({
                        children: [
                            new TableCell({
                                width: {
                                    size: 2000, // Sol sütun daha küçük
                                    type: WidthType.DXA,
                                },
                                children: [new Paragraph(formatReference(jsonMessageDetails[rowIndex], citationFormat))], // Sol sütun verisi
                            }),
                            new TableCell({
                                width: {
                                    size: 7010, // Sağ sütun daha geniş
                                    type: WidthType.DXA,
                                },
                                children: [new Paragraph(row[1])], // Sağ sütun verisi
                            }),
                        ],
                    });
                });

                // uzun metnin oluşturulması.
                const paragraph = new Paragraph({
                    children: [
                        new TextRun(uzunMetin[0]) // Metni tek bir TextRun içinde tutuyoruz
                    ],
                    spacing: {
                        before: 200,
                        after: 200
                    },
                    alignment: AlignmentType.JUSTIFIED
                });

                const doc2 = new Document({
                    sections: [
                        {
                            properties: {},
                            children: [
                                title,
                                keywordsHeading,
                                keywordsList,
                                keywordsSpacing,
                                new Table({
                                    columnWidths: [2000, 7010],
                                    rows: tableRows, // Dinamik oluşturulan satırlar ekleniyor
                                }),
                                paragraph,
                                referencesHeading,
                                ...referencesList
                            ],
                        },
                    ],
                });

                Packer.toBlob(doc2).then((blob) => {
                    saveAs(blob, `${cleanMarkdown(response.question).slice(0, 50)}_makale.docx`);
                });
            }


        } catch (error) {
            console.error("Doküman oluşturma hatası:", error);
            alert("Doküman oluşturulurken bir hata oluştu.");
        }
    };
    0

    const handleRefresh = () => {
        if (searchQuery) {
            fetchResponse(searchQuery);
        }
    };

    return (
        <div className="results-page">
            {showToast && (
                <Toast
                    message={
                        !response?.text
                            ? "Kopyalanacak bir içerik yok."
                            : "Metin başarıyla kopyalandı!"
                    }
                    error={!response?.text}
                    onClose={() => setShowToast(false)}
                />
            )}
            <LeftTabs
                queries={queries}
                deeperQuestion={isLoading ? null : messageDetails?.deeper_question}
                onMessageSelect={handleMessageSelect}
                allMessages={allMessages}
                selectedMessageId={selectedMessageId}
                onQuestionSelect={(question) => setResultSearchQuery(question)}
            />

            <div className="middle-section">
                <div className="conversation">
                    <div className="question-box">
                        {response?.question || searchQuery || 'Sorgunuz burada görünecek...'}
                    </div>
                    <div className="message-box" ref={messageBoxRef}>
                        {isLoading ? (
                            <DocumentLoader />
                        ) : (
                            <div className="message-content">
                                {formatMarkdown(response?.text)}
                            </div>
                        )}
                    </div>
                </div>
                <div className="controls-wrapper">
                    <div className="search-bar-container">
                        <SearchBar
                            onSearch={handleSearchRequest}  // searchQuery ile arama yapılacak
                            value={resultSearchQuery}       // arama kutusundaki değer
                            onChange={setResultSearchQuery} // arama kutusu değeri değiştiğinde güncelle
                            searchSettings={searchSettings} // Search settings (örn: filitering, search scope vs.)
                            onSettingsApply={handleSettingsApply} // search settings için apply fonksiyonu
                            isMainPage={false} // buradaki page type
                            files={selectedFiles}  // dosya seçimlerini buraya geçiyoruz
                            setFiles={setSelectedFiles}  // dosyaların state'ini güncellemek için
                            fileProcessType={fileProcessType}  // arama tercihi (sadece dosyalar ya da geniş arama)
                            setFileProcessType={setFileProcessType}  // file process type'ı değiştirebilme
                        />

                    </div>
                    <div className="download-icon-container">
                        <button className="icon-button" onClick={handleCopy}>
                            <FaCopy size={22} />
                        </button>
                        <button className="icon-button" onClick={handleDownload}>
                            <TbFileDownload size={24} />
                        </button>
                        {/*
                        <button className="icon-button" onClick={handleDownload}>
                            <BsTranslate size={24}/>
                        </button>
                        */}
                        <button className="icon-button" onClick={handleRefresh}>
                            <FiRefreshCw size={22} />
                        </button>
                        <button className="icon-button" onClick={handleInfoClick}>
                            <FiInfo size={22} />
                        </button>

                    </div>
                </div>
            </div>

            <RightTabs
                allReferences={isLoading ? null : messageDetails?.all_references}
                search_strategy={isLoading ? null : messageDetails?.search_strategy}
                extReferences={isLoading ? null : messageDetails?.ext_references}
            />
        </div>
    );
};


export default ResultsPage;